import { render, staticRenderFns } from "./SliceTile.vue?vue&type=template&id=5a717028&lang=pug&"
import script from "./SliceTile.vue?vue&type=script&lang=js&"
export * from "./SliceTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports